export default __webpack_public_path__ + "static/media/SunPath.9c384caf.svg";